<template>
  <div ref="pupilRef" class="pupil" :style="{
    width: size + 'px', height: size + 'px',
    backgroundColor: pupilColor,
    transform: `translate(${pos.x}px, ${pos.y}px)`,
  }" />
</template>

<script>
export default {
  name: 'Pupil',
  props: {
    size: { type: Number, default: 12 },
    maxDistance: { type: Number, default: 5 },
    pupilColor: { type: String, default: 'black' },
    forceLookX: { type: Number, default: undefined },
    forceLookY: { type: Number, default: undefined },
  },
  data() {
    return {
      mx: 0,
      my: 0,
    }
  },
  computed: {
    pos() {
      const pupilRef = this.$refs.pupilRef
      if (!pupilRef) return { x: 0, y: 0 }
      if (this.forceLookX !== undefined && this.forceLookY !== undefined) {
        return { x: this.forceLookX, y: this.forceLookY }
      }
      const r = pupilRef.getBoundingClientRect()
      const dx = this.mx - (r.left + r.width / 2)
      const dy = this.my - (r.top + r.height / 2)
      const d = Math.min(Math.sqrt(dx ** 2 + dy ** 2), this.maxDistance)
      const a = Math.atan2(dy, dx)
      return { x: Math.cos(a) * d, y: Math.sin(a) * d }
    },
  },
  methods: {
    onMove(e) {
      this.mx = e.clientX
      this.my = e.clientY
    },
  },
  mounted() {
    window.addEventListener('mousemove', this.onMove)
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.onMove)
  },
}
</script>

<style scoped>
.pupil { border-radius: 50%; transition: transform 0.1s ease-out; }
</style>
